module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-04.fc12f23.webp";